import { SEO_DEFAULTS } from './constants';

export interface BreadcrumbItem {
  name: string;
  url: string;
}

export function generateOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": SEO_DEFAULTS.siteName,
    "url": SEO_DEFAULTS.siteUrl,
    "logo": `${SEO_DEFAULTS.siteUrl}/kept-scene-logo.png`,
    "description": SEO_DEFAULTS.siteDescription,
    "email": "keptscene@gmail.com",
    "sameAs": [
      // Add social media links if available
    ]
  };
}

export function generateWebSiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": SEO_DEFAULTS.siteName,
    "url": SEO_DEFAULTS.siteUrl,
    "description": SEO_DEFAULTS.siteDescription,
    "publisher": {
      "@type": "Organization",
      "name": SEO_DEFAULTS.siteName
    }
  };
}

export function generateBreadcrumbListSchema(items: BreadcrumbItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
}

export function generateServiceSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Photo Booth Service",
    "description": SEO_DEFAULTS.siteDescription,
    "provider": {
      "@type": "Organization",
      "name": SEO_DEFAULTS.siteName
    },
    "serviceType": "Photo Booth",
    "areaServed": {
      "@type": "Country",
      "name": "Thailand"
    }
  };
}

